module.exports = __webpack_public_path__ + "img/LOGO-GRUPO-CARS.ed62df90.png";